import * as filterHeaderTypes from '../../../webcommon/header/filterheader/propTypes';
import { lastWorkingDay } from '../../../common/helpermethods/HelperMethods';

export const PAGE_REFRESH_RATE = 60000;

export const filterDefinitions = [
    {
        id: 'runDate',
        title: 'EOD Date',
        type: filterHeaderTypes.filterTypes.date,
        defaultValue: { from: lastWorkingDay(), to: lastWorkingDay(), today: false },
        availableValues: undefined,
        availableValuesLocation: undefined,
        server: true,
        useValidation: true,
        hideAllButton: true,
        hideToday: true
    }
];

export const defaultFilters = [
    {
        value: {
            from: lastWorkingDay(),
            to: lastWorkingDay(),
            today: false
        },
        definition: filterDefinitions.find(def => def.id === 'runDate')
    }
];

export const columns = [
    {
        id: 'checkbox',
        visible: true
    },
    {
        id: 'source',
        visible: true,
        sortable: true
    },
    {
        id: 'category',
        visible: true,
        sortable: true
    },
    {
        id: 'businessDate',
        visible: true,
        sortable: true
    },
    {
        id: 'timestamp',
        visible: true,
        sortable: true
    },
    {
        id: 'errorMessage',
        visible: true,
        sortable: true
    },
    {
        id: 'status',
        visible: true,
        sortable: true
    }
];
